import React from 'react';
import { LinearProgress, styled } from '@mui/material';

const Container = styled('div')({
  display: 'flex',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  alignItems: 'center',
  position: 'fixed',
  backgroundColor: '#f7f7f7',
  zIndex: 2000,
  flexDirection: 'column',
});

const Logo = styled('img')({
  width: 300,
  borderRadius: '50%',
});

const Progress = styled('div')({
  width: 200,
  marginTop: 50,
});

const Content = styled('div')({
  top: '30%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
});

const SplashScreen: React.FC = () => {
  return (
    <Container>
      <Content>
        <Logo
          src="https://h2i.s3.sa-east-1.amazonaws.com/upload/images/17001920260102695823d310ede.png"
          alt="Universo Plástica logo"
        />
        <Progress>
          <LinearProgress color="primary" />
        </Progress>
      </Content>
    </Container>
  );
};

export default SplashScreen;
